import { useTheme } from "@mui/material";
import { PageHeader, PageHeaderProps } from "./PageHeader";
import Box from "@mui/material/Box";
import { useRef } from "react";
import { useElementDimension } from "@sal/onevent-portal";

type PageLayoutProps = PageHeaderProps & {
	disableOverflow?: boolean;
	headerElement?: React.ReactNode;
};
export function PageLayout({ title, disableOverflow, children, headerElement }: React.PropsWithChildren<PageLayoutProps>) {
	const theme = useTheme();

	const headerRef = useRef<HTMLElement>();
	const { offsetHeight: headerHeight } = useElementDimension(headerRef);

	return (
		<Box width="100%" height="100%" display="flex" flexDirection="column">
			<Box
				ref={headerRef}
				display="flex"
				flexDirection="row"
				flexGrow={0}
				justifyContent="space-between"
				paddingTop={theme.spacing(8)}
				paddingBottom={theme.spacing(6)}
				paddingX={theme.spacing(16)}
				bgcolor={theme.palette.common.white}
				width="100%"
			>
				<PageHeader title={title} />
				{headerElement}
			</Box>
			<Box flex={`0 0 ${theme.spacing(12)}`} bgcolor={theme.palette.common.white} />
			<Box
				flexGrow={1}
				marginTop={`-${theme.spacing(12)}`}
				paddingBottom={theme.spacing(4)}
				paddingX={theme.spacing(16)}
				maxHeight={disableOverflow ? `calc(100% - ${headerHeight}px)` : "none"}
				minHeight={disableOverflow ? `calc(${headerHeight}px + 600px)` : "none"}
			>
				{children}
			</Box>
		</Box>
	);
}
